import { EXTRA_EXTRA_LARGE_MEDIAQUERY, EXTRA_LARGE_MEDIAQUERY, LARGE_MEDIAQUERY, MEDIUM_MEDIAQUERY, SMALL_MEDIAQUERY, } from '../ResponsiveBreakpoints';
import { useMatchMedia } from './useMatchMedia';
export function useResponsiveBreakpoint() {
    var isSmallBreakpoint = useMatchMedia(SMALL_MEDIAQUERY);
    var isMediumBreakpoint = useMatchMedia(MEDIUM_MEDIAQUERY);
    var isLargeBreakpoint = useMatchMedia(LARGE_MEDIAQUERY);
    var isExtraLargeBreakPoint = useMatchMedia(EXTRA_LARGE_MEDIAQUERY);
    var isExtraExtraLargeBreakPoint = useMatchMedia(EXTRA_EXTRA_LARGE_MEDIAQUERY);
    if (isSmallBreakpoint) {
        return 'Small';
    }
    else if (isMediumBreakpoint) {
        return 'Medium';
    }
    else if (isLargeBreakpoint) {
        return 'Large';
    }
    else if (isExtraLargeBreakPoint) {
        return 'ExtraLarge';
    }
    else if (isExtraExtraLargeBreakPoint) {
        return 'ExtraExtraLarge';
    }
    else {
        return 'ExtraExtraExtraLarge';
    }
}
//# sourceMappingURL=useResponsiveBreakpoint.js.map